'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

import { LinkViewModel } from '@api/v3';
import { useQueryParams } from '@hooks/useQueryParams';

import {
  Container,
  Item,
  ItemContainer,
  Separate,
  SideBarChild,
  ChildTitleWrapper,
} from './styled';

export interface Props {
  item: LinkViewModel;
  selected?: string;
  staticPageSubPath: string;
}
export const SidebarChild = ({ item, staticPageSubPath }: Props) => {
  const pathname = usePathname();
  const query = useQueryParams();
  const isSelected =
    query?.slug === item.href.split('/')[1] || pathname === item.href;
  return (
    <Container>
      <SideBarChild>
        <ItemContainer>
          <ChildTitleWrapper>
            {item.external ? (
              <Link
                target='_blank'
                href={item.href}
                rel='noopener noreferrer'
                prefetch={false}
              >
                <Item>{item.name}</Item>
              </Link>
            ) : (
              <Link href={staticPageSubPath + item.href} prefetch={false}>
                <Item isColor={isSelected}>{item.name}</Item>
              </Link>
            )}
          </ChildTitleWrapper>
        </ItemContainer>
        <Separate isColor={isSelected} />
      </SideBarChild>
    </Container>
  );
};
export default SidebarChild;
